import { Controller, useFormContext } from 'react-hook-form';
import { BrgModelProps, FormData } from './BrgClaimForm.types';
import clsx from 'clsx';
import { RadioButton } from '@marriott/mi-ui-library';

interface BrgRewardsInfoProps {
  rewardsInformation: BrgModelProps['rewardsInformation'];
}

export function BrgRewardsInfo({ rewardsInformation }: BrgRewardsInfoProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormData>();

  const radioOptions = [
    {
      id: 'radio-rate',
      label: rewardsInformation.isRateRadioButtonLabel,
      value: rewardsInformation.isRateRadioButtonLabel,
    },
    {
      id: 'radio-point',
      label: rewardsInformation.isPointRadioButtonLabel,
      value: rewardsInformation.isPointRadioButtonLabel,
    },
  ];

  return (
    <div id="rewards-info" className="">
      <h2>{rewardsInformation.componentTitle}</h2>
      <p className="mb-4">{rewardsInformation.componentDescription}</p>
      <div
        className={clsx('m-input-field', {
          'focus-error-indicator': !!errors.isPointsRate,
        })}
      >
        {radioOptions.map(({ id, label, value }) => (
          <Controller
            key={id}
            name="isPointsRate"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <RadioButton
                radiobuttonId={id}
                radiobuttonName="isPointsRate"
                className="m-radio-button my-3"
                radiobuttonLabel={label!}
                checked={field.value === value}
                onChange={field.onChange}
                value={value!}
                setTabIndex={0}
              />
            )}
          />
        ))}
        {errors.isPointsRate && (
          <div className="m-input-field is-error mt-n3">
            <span>{rewardsInformation.errorLabel}</span>
          </div>
        )}
      </div>
    </div>
  );
}
